module.exports = __webpack_public_path__ + "img/sappasamit.b1ab47f2.png";